import React from "react";
import male from "../../../assets/images/male.png";
import "./guideCard.css";
import angle from "../../../assets/images/rightAngle.svg";
import { Link } from "react-router-dom";



function GuideCard({ data = {} }) {
  return (
    <Link to={`/guide-details/${ data.id }`} className="guide-card">
      <div className="guide-card-img-container">
        <img src={data.file?.Url || male} className="guide-card-img" alt="" />
      </div>
      <div className="w-100">
        <div className="d-flex w-100  justify-content-between">
          <div className="">
              <h6 className="fs-5 mb-0 custom-text-color">{ data.name }</h6>
          </div>
          <div className=" fs-9">
            <div className="text-warning me-2 fs-9 d-flex">
              {
                Array(parseInt(data.rating) || 0).fill(0).map(( _, i )=> 
                  <i className="bi bi-star-fill"></i>
                )
              }
              {
                Array(5 - parseInt(data.rating) || 0).fill(0).map(( _, i )=> 
                  <i className="bi bi-star"></i>
                )
              }
              <span className="ms-2 text-dark">{ data.rating }/5</span>
            </div>
          </div>
        </div>
        <div className="">
          <p className="mb-0 text-secondary">{ data.cityId?.name }</p>
          <div className="d-flex justify-content-between mt-1 align-items-center">
                <span class="pricing">Rs.{ data.pricePerHour }</span>
                <div>
                  <span className="angle-icon"><img src={angle} className="w-100 h-100" alt="" /></span>
                </div>
          </div>
        </div>
      </div>
    </Link>
  );
}

export default GuideCard;
